import React from "react";



const Booklist = () => {
    const pdfFiles = [
        { name: 'Booklist, HGS school Bhopal', url: '../newdocuments/Booklist Template 2026 (1).docx'},
        { name: 'Booklist, HGS school Bhimtal', url: '../disclosure2026/Booklist-bhimtal 2026-2027.docx'},
        { name: 'Booklist, HGS school Anangpur', url: '../newdocuments/Booklist anagpur.pdf'},
        { name: 'Booklist, HGS school Palla Nuh', url: '../newdocuments/1205/Booklist Template 2026 (5).docx'},
        { name: 'Booklist, HGS school Varanasi', url: '../disclosure2026/Booklist varanasi2026 VRN.docx'},
        { name: 'Booklist, HGS school Jammu', url: '../disclosure2026/Booklist Template 2026 (1).docx'},
        { name: 'Booklist, HGS school Faridabad', url: '../newdocuments/BOOK LIST-HGS Faridabad.docx'}
      
      ];
  
 
  return (
    <div className="home_main">
      {/* <Navbar isScrolled={true} handleClick={handleClick} /> */}
      <div className="pdf-container">
      <table className="pdf-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Filename</th>
            <th>Link To Documents</th>
          </tr>
        </thead>
        <tbody>
          {pdfFiles.map((file, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{file.name}</td>
              <td>
                <a href={file.url} target="_blank" rel="noopener noreferrer">
                  View
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
      
    </div>
  );
};

export default Booklist;
